import React, { useState } from 'react';
import UserTopbar from '../UserTopbar';
import { Download } from '@mui/icons-material'; 
import Loader from '../utils/Loader';

const Manual = () => {
  const [isLoading, setIsLoading] = useState(false);
  
  const handleDownload = () => {
    setIsLoading(true);
    
    const manualUrl = "https://quotationsapis1.groheapp.in/public/excel/quotation_formate.pdf"; 
    
    
    window.open(manualUrl, '_blank'); 
    
    setIsLoading(false);
  };
  

  return (
    <>
      <UserTopbar heading={"Manual"} />
      {isLoading && <Loader />} 
      <div className="flex justify-center items-center mt-20 px-4">
        <div className="bg-white/60 backdrop-blur-md rounded-3xl shadow-xl border border-white/50 p-12 text-center max-w-lg w-full flex flex-col items-center gap-6">
          <div className="bg-gradient-to-tr from-[#ff7b00]/20 to-orange-200 p-4 rounded-full">
            <Download sx={{ fontSize: 48, color: "#ff7b00" }} />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">User Manual</h2>
            <p className="text-gray-600 mb-6 text-sm">Download the complete guide on how to use the Grohe Quotation platform.</p>
            <button
              onClick={handleDownload}
              className="flex items-center mx-auto bg-[#ff7b00] text-white py-3 px-8 rounded-full shadow-[0_4px_14px_0_rgba(255,123,0,0.39)] hover:shadow-[0_6px_20px_rgba(255,123,0,0.23)] hover:-translate-y-1 hover:bg-[#e06a00] transition-all duration-300"
            >
              <Download className="mr-2" />
              <span className="text-lg font-semibold tracking-wide">Download PDF</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Manual;
